import { inject, Injectable } from "@angular/core";
import { MICustomFunctionsParams } from "../../models/fields/custom-function-params";
import { ManufacturersFunctions } from "../authorities/common/manufacturers.service";
import { AuthoritiesEventsCommunication } from "../authorities/events/communication/service";
import { MICustomBookService } from "../authorities/common/custom-book/custom-book";
import { QuantityUnitCode } from "../authorities/common/quantiny-unitcode";
import { AuthoritiesEventsTransportation } from "../authorities/events/transportation/service";
import { AuthoritiesEventsEconomy } from "../authorities/events/economy/service";
import { MCAuthoritiesEventsRegisteryService } from "@maslul/common-services";

@Injectable({
    providedIn: 'root'
})
export class EventsCallBackService {

    private manufacturersService = inject(ManufacturersFunctions);
    private communicationService = inject(AuthoritiesEventsCommunication);
    private customBookService = inject(MICustomBookService);
    private quantityUnitCode = inject(QuantityUnitCode);
    private transportService = inject(AuthoritiesEventsTransportation);
    private economyService = inject(AuthoritiesEventsEconomy);
    private registery = inject(MCAuthoritiesEventsRegisteryService);

    callFunction(functionName: string, customFunctionsObj: MICustomFunctionsParams) {
        if (this.registery.eventsCallBack[functionName]) {
            return this.registery.eventsCallBack[functionName](customFunctionsObj);
        }
        if (this.eventsCallBack[functionName]) {
            return this.eventsCallBack[functionName](customFunctionsObj);
        }
    }

    hasFunction(functionName: string): boolean {
        return !!(this.registery.eventsCallBack[functionName] || this.eventsCallBack[functionName]);
    }

    eventsCallBack: Record<string, Function> = {

        "updateManufacturerNameFromValues": (customFunctionsParams: MICustomFunctionsParams) => {
            return this.manufacturersService.updateManufacturerNameFromValues(customFunctionsParams);
        },
        "fillManufacturerList": (customFunctionsParams: MICustomFunctionsParams) => {
            return this.manufacturersService.fillManufacturerList(customFunctionsParams);
        },


        "getCustomItemFromList": (customFunctionsParams: MICustomFunctionsParams) => {
            return this.communicationService.getCustomItemFromList(customFunctionsParams);
        },
        "initCustomItemByPrice": (miCustomFunctionsParams: MICustomFunctionsParams) => {
            return this.communicationService.initCustomItemByPrice(miCustomFunctionsParams);
        },
        "initCustomItemList": (miCustomFunctionsParams: MICustomFunctionsParams) => {
            return this.customBookService.initCustomItemList(miCustomFunctionsParams);
        },
        "insertValueToCustomItem": (miCustomFunctionsParams: MICustomFunctionsParams) => {
            return this.transportService.transportCustomItem(miCustomFunctionsParams);
        },

        "setEveryoneDeclareUnitCode": (customFunctionsParams: MICustomFunctionsParams) => {
            return this.quantityUnitCode.setEveryoneDeclareUnitCode(customFunctionsParams);
        },
        "getModelCodeList": this.noImplementFunction,
        "newValueAddedToModelCodeList": this.noImplementFunction,
        "setModelCodeChanged": this.noImplementFunction,
        "initCustomItemBySpecific": (miCustomFunctionsParams: MICustomFunctionsParams) => {
            return this.communicationService.initCustomItemBySpecific(miCustomFunctionsParams);
        },
        "onCustomItemSelected": (miCustomFunctionsParams: MICustomFunctionsParams) => {
            return this.customBookService.onCustomItemSelected(miCustomFunctionsParams);
        },
        "getProductTypeSelectionList": (customFunctionsParams: MICustomFunctionsParams) => {
            return this.economyService.getProductTypeSelectionList(customFunctionsParams);
        },
        "onProductTypeSelected": (customFunctionsParams: MICustomFunctionsParams) => {
            return this.economyService.onProductTypeSelected(customFunctionsParams);
        },
        "onCustomsItemSelectionChanged": (customFunctionsParams: MICustomFunctionsParams) => {
            return this.economyService.onCustomsItemSelectionChanged(customFunctionsParams);
        },
        "initCustomsItemSelectionList": (customFunctionsParams: MICustomFunctionsParams) => {
            return this.economyService.initCustomsItemSelectionList(customFunctionsParams);
        }

    }

    noImplementFunction(functionName: string) {
        console.warn("no implement for function: " + functionName + " in MI")

    }
}
